
 <script src="https://cdn.tiny.cloud/1/uutzwz4lwkfsnltufrr5wm1nl4ssackw9elots7t7cptq0ta/tinymce/5/tinymce.min.js" referrerpolicy="origin"></script>
<template>
	<section>
		<div class="row field">
			<div class="col-md-12">
				<fieldset>
					<div class="field-title">
						<div class="legend">
							Estrutura
						</div>
					</div>

					<div class="container-fluid">
						<div class="row">
							<div class="col-12">
								<div class="form-group">
				                    <label  for="mailto">Cabeçalho:</label>
				                    <tinymce-editor v-model="params.relatorio_header" api-key="tiny_key" :init="editor_init"></tinymce-editor>
				                </div>
							</div>

							<div class="col-12">
								<div class="form-group">
				                    <label  for="mailcc">Rodapé:</label>
				                    <tinymce-editor v-model="params.relatorio_footer" api-key="tiny_key" :init="editor_init"></tinymce-editor>
				                </div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
		</div>

		<div class="row field">
			<div class="col-md-12">
				<fieldset>
					<div class="field-title">
						<div class="legend">
							Trechos predefinido
						</div>
					</div>

					<div class="container-fluid">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
				                    <label  for="mailto">Relatório:</label>
				                    <tinymce-editor v-model="params.relatorio_txt_relatorio" :api-key="tiny_key" :init="editor_init"></tinymce-editor>
				                </div>
							</div>

							<div class="col-md-6">
								<div class="form-group">
				                    <label  for="mailcc">Referente:</label>
				                    <tinymce-editor v-model="params.relatorio_txt_referente" api-key="tiny_key" :init="editor_init"></tinymce-editor>
				                </div>
							</div>

							<div class="col-md-6">
								<div class="form-group">
				                    <label  for="mailcc">Destinatário:</label>
				                    <tinymce-editor v-model="params.relatorio_txt_destinatario" api-key="tiny_key" :init="editor_init"></tinymce-editor>
				                </div>
							</div>

							<div class="col-md-6">
								<div class="form-group">
				                    <label  for="mailcc">Assinatura:</label>
				                    <tinymce-editor v-model="params.relatorio_txt_assinatura" api-key="tiny_key" :init="editor_init"></tinymce-editor>
				                </div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
		</div>

		<div class="d-flex flex-row-reverse bd-highlight mb-3">
			<button @click="save" class="btn btn-sm btn-success">Salvar</button>
		</div>
		
	</section>
</template>
<script>
	import Editor from '@tinymce/tinymce-vue'
	import api    from "@/mixins/api.js"

	export default { 
		name: "Relatorio_Config",
		components: { 'tinymce-editor': Editor },
		mixins: [api],

		data: () => { 
			return {
				tiny_key: "uutzwz4lwkfsnltufrr5wm1nl4ssackw9elots7t7cptq0ta",
				params: null,
			}
		},

		created() {
			this.params = this.config;
		},

		methods: {
			async save() {
				const response = await this.PUT("Config", this.params);

				if ( response.status == 'success' ){
					this.$store.dispatch("update_config", response.data );
				}

				this.$emit('alert', response);
			}
		},

		computed: {
			config() { 
				return this.$store.state.config;
			},

			editor_init() {
				return {
					height: '300px',
					width: '100%',
					plugins: [
						"advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste"
					],
					toolbar: "fullscreen | table bold italic forecolor backcolor | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify",
					statusbar:  false,
					menubar:    false,
					browser_spellcheck : true,
					paste_data_images: true,

					extended_valid_elements: 'i[class|alt|title],a[href|onclick],tcpdf[method|params]',
					content_css: [
					'//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
					'//www.tiny.cloud/css/codepen.min.css'],
				}
			}
		}
	}
</script>

<style>
	
</style>